// ============================================================
// ⏱️ rafraichissement — chargements périodiques d'une page.
// - un seul chargement à la fois (chaîne de setTimeout, pas de setInterval) ;
// - chargement initial différé : un démontage immédiat l'annule, si bien que
//   le double montage de React.StrictMode en développement ne charge qu'une fois ;
// - délai imposé par le serveur (Retry-After) respecté, même au-delà de
//   l'intervalle habituel ; jamais de nouvel essai immédiat.
// ============================================================

/**
 * `charger()` renvoie (éventuellement) `{ retryAfterMs }` : délai minimal avant
 * le prochain chargement, tel qu'imposé par le serveur.
 */
export function creerRafraichissement(charger, { intervalleMs = 10000, horloge } = {}) {
  const h = horloge || { setTimeout: (f, d) => setTimeout(f, d), clearTimeout: (t) => clearTimeout(t), now: () => Date.now() };
  let minuteur = null;
  let enCours = false;
  let arrete = true;
  let pasAvant = 0; // aucun chargement avant cet instant (Retry-After)

  const planifier = (delai) => {
    minuteur = h.setTimeout(executer, delai);
  };

  async function executer() {
    minuteur = null;
    if (arrete || enCours) return;
    enCours = true;
    let attente = intervalleMs;
    try {
      const r = await charger();
      if (r && Number.isFinite(r.retryAfterMs) && r.retryAfterMs > 0) {
        pasAvant = h.now() + r.retryAfterMs;
        attente = Math.max(attente, r.retryAfterMs);
      }
    } finally {
      enCours = false;
    }
    if (!arrete) planifier(attente);
  }

  return {
    demarrer() {
      if (!arrete) return;
      arrete = false;
      planifier(0);
    },
    arreter() {
      arrete = true;
      if (minuteur !== null) h.clearTimeout(minuteur);
      minuteur = null;
    },
    /** Rafraîchissement manuel : refusé pendant un chargement ou avant Retry-After. */
    rafraichirMaintenant() {
      if (arrete || enCours || h.now() < pasAvant) return false;
      if (minuteur !== null) h.clearTimeout(minuteur);
      planifier(0);
      return true;
    },
  };
}
